import React, { Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite';

import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { Status } from '../../../components/Status';
import { venueMarkerData } from '../../../data/data';
import { AppConfig } from '../../../AppConfig';
import { Helper } from '../../../common/helpers/Helper';
import { Grid } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';
import { Stats } from '../../../components/Stats';

export class PartnerDashboardCharts extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.orgId = this.props.match.params.orgId
    this.pageTitle = 'Dashboard'
    this.pageKey = 'partnerDashboard'
    this.toFetch = []
    this.noAdd = true
    this.state = {
      chartsData: [],
      stats:[]
    }

    const queryParams = {
      orgId:this.orgId
    }
    this.toFetch = [{ method: 'GET', paths: ['miscs', 'dashboard-of-org'], queryParams }]
    // ChartsOptions
    // this.chartOptions = {
    //   responsive: true,
    //   legend: {
    //     position: 'right',
    //     onClick: function(e, legendItem) {
    //       e.preventDefault();
    //     }
    //   },
    //   cutoutPercentage: 70
    // };
    this.chartOptions = {
      cutoutPercentage: 70,
      responsive: true,
      legend: {
        display: true,
        position: 'right',
        margin: {
          top: 0,
          bottom: 0
        },
        labels: {
          boxWidth: 8,
          fontSize: 10,
        },
        onClick: function(e, legendItem) {
          e.preventDefault();
        }
      },
      layout: {
        autoPadding:false,
        padding: {
          bottom: 0,
          top: 0
        }
      },
      maintainAspectRatio: false
    };
    this.charts = {};
  }

  onFetchSuccess(results) {
    const venuesResult = results[0]
    if (venuesResult.dashboard || venuesResult.stats) this._generateChartsFromStats(venuesResult.dashboard || venuesResult.stats)
  }

  _generateChartsFromStats(stats) {
    const allCharts = []
    const allStats = []
    const backgroundColors = [
      '#645CAA',
      '#A084CA',
      '#BFACE0',
      '#BFACE0',
      '#800080',
      '#EBC7E8',
    ]
    const renameValues = {
      red: 'Offline',
      orange: 'Standby',
      green: 'Online'
    }
    const onlineStatusColors = {
      red: '#FF1512',
      orange: '#e1ad01',
      green: '#238822'
    }
    const images = {
      devices: require('../../../assets/icons/dashboard-icons.svg'),
      campaigns: require('../../../assets/icons/campaign.svg'),
      assets: require('../../../assets/icons/media-dashboard-icon.svg')
    }
    // Separate chart and stats
    for (const key in stats) {
      if (typeof stats[key] === 'object' && !Array.isArray(stats[key])) {
        this.charts[key] = stats[key];
      } else {
        allStats.push({
          title:key[0].toUpperCase() + key.slice(1),
          value:stats[key],
          image:images[key.toLowerCase()]
        })
      }
    }
    Object.keys(this.charts).map(x => {
      const hasValueGreaterThanZero = Object.values(stats[x]).some(value => value > 0);
      const tempData = {
        labels: (x === 'onlineStatus') ? Object.keys(stats[x]).map(x => renameValues[x].toUpperCase() || x) : Object.keys(stats[x]),
        datasets: [
          {
            data: Object.values(stats[x]),
            backgroundColor: (x === 'onlineStatus') ? Object.keys(stats[x]).map((x, index) => onlineStatusColors[x] || backgroundColors[index]) : backgroundColors,
            borderColor: (x === 'onlineStatus') ? Object.keys(stats[x]).map((x, index) => onlineStatusColors[x] || backgroundColors[index]) : backgroundColors,
            hoverBackgroundColor: (x === 'onlineStatus') ? Object.keys(stats[x]).map((x, index) => onlineStatusColors[x] || backgroundColors[index]) : backgroundColors,
            borderWidth: 0,
          },
        ],
      }
      allCharts.push({
        chartTitle: x === 'osVersion' ? Helper.getString('osVersion') : this._camelCaseToCapitalizedWords(x),
        data: tempData,
        hasDataMoreThanZero: hasValueGreaterThanZero
      })
    })
    this.setState({
      chartsData: allCharts,
      stats:allStats
    })
  }
  _camelCaseToCapitalizedWords(camelCaseString) {
    try {
      return camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/^./, function (str) {
          return str.toUpperCase();
        });
    } catch(e) {
      return camelCaseString
    }
  }
  renderTable() {
    return (
      <Fragment>
        <div className={css(Styles.mainContainer)}>
          <div className={css(Styles.statsHolder)}>
            { this.state.stats && <Stats lg={4} items={this.state.stats}></Stats> }
          </div>
          <div>
            { this.state.chartsData && this.state.chartsData.length > 0 &&
              <Grid className={css(Styles.chartsContainer)} container spacing={2}>
                {this.state.chartsData.map((x, index) => {
                  return (
                    <Grid item key={'chart_' + index} className={css(Styles.eachChartHolder)} xs={12} md={4}>
                      <div className={css(Styles.chartOuterWrap)} >
                        <div className={css(Styles.chartBlock)} >
                          {x.chartTitle &&
                            <div className={css(Styles.chartTitle)}>{x.chartTitle}</div>
                          }
                          {x.hasDataMoreThanZero === false ?
                            <div className={css(Styles.noChartMessage)}>{Helper.getString('noChartDataMessage')}</div> :
                            <Doughnut className={css(Styles.chartCanvas)} data={x.data} options={this.chartOptions} width={100} height={100} />}
                        </div>
                      </div>
                    </Grid>
                  )
                })}
              </Grid>
            }
          </div>
        </div>
      </Fragment>
    );
  }
}

const Styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: AppTheme.primaryBg,
    width: '100%',
    '@media (max-width: 1025px)': {
      width: '97vw !important'
    }
  },
  eachChartHolder:{
    // padding:0,
    // marginBottom:12
  },
  chartsContainer:{
    marginTop: '5px 0px',
    margin: '15px 0px',
    width: '100%',
  },
  chartOuterWrap:{
    background: '#fff',
    height: 214,
    borderRadius: 16
  },
  chartBlock: {
    borderRadius: 16,
    padding: '10px 10px 10px 10px',
    // background: '#fff',
    // marginRight:10,
    // overflow: 'hidden',
    height: 160
  },
  chartTitle:{
    fontSize: 16,
    color: '#121212',
    padding: 4
  },
  chartCanvas:{
    marginBottom: 10
  },
  statsHolder:{
    padding: '0 10px'
  },
  noChartMessage: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    flexDirection: 'column',
    textAlign: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/partners/PartnerDashboardCharts.js